var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacturaLogoIconGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 141,
    viewBox: "0 0 142 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 58.75V52.875C118 47.4114 118 44.6796 117.4 42.4383C115.77 36.3561 111.019 31.6053 104.937 29.9755C102.696 29.375 99.9638 29.375 94.5 29.375",
    stroke: "currentStroke",
    strokeWidth: 16,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 82.25V88.125C118 93.5887 118 96.3206 117.4 98.5619C115.77 104.644 111.019 109.395 104.937 111.025C102.696 111.625 99.9638 111.625 94.5 111.625",
    stroke: "currentStroke",
    strokeWidth: 16,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.25 111.625H53.375C42.3933 111.625 36.9024 111.625 32.8125 109.264C30.1331 107.717 27.9082 105.492 26.3613 102.812C24 98.7223 24 93.2315 24 82.25",
    stroke: "currentStroke",
    strokeWidth: 16,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.25 29.375H53.375C42.3933 29.375 36.9024 29.375 32.8125 31.7363C30.1331 33.2832 27.9082 35.5081 26.3613 38.1875C24 42.2774 24 47.7683 24 58.75",
    stroke: "currentStroke",
    strokeWidth: 16,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.25 123.375V17.625",
    stroke: "currentStroke",
    strokeWidth: 16,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacturaLogoIconGreen);
export default __webpack_public_path__ + "static/media/FacturaLogoIconGreen.150f6fe332afaf65c23cbb0932008b76.svg";
export { ForwardRef as ReactComponent };